var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 211,
    viewBox: "0 0 212 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.997 151.64H1.24723C-1.63909 147.34 1.52212 139.591 5.30182 136.346C9.08153 133.1 13.8233 131.397 16.9158 127.299C21.7951 120.89 20.9704 111.153 20.5237 102.553C20.077 93.9526 21.0735 83.6078 27.5334 79.5916C33.4778 75.8594 40.9685 79.5916 47.4284 77.3604C53.8195 75.1292 57.6679 67.7459 61.5507 61.3768C74.6079 40.1193 94.6403 25.0281 116.46 20.0383C125.84 17.8882 135.874 17.6042 144.704 21.945C153.535 26.2857 160.854 36.0625 161.369 47.3403C161.747 55.3322 158.792 62.9183 157.315 70.7073C155.837 78.4963 156.284 87.9486 161.679 92.7761C166.042 96.7112 172.021 96.265 177.485 97.0763C182.914 97.8877 189.167 101.62 189.305 108.07C189.477 115.088 182.192 120.727 183.67 127.543C184.597 131.681 188.446 133.912 192.019 134.642C195.593 135.372 199.407 135.251 202.671 137.157C205.97 139.104 210.059 148.11 207.997 151.64Z",
    fill: "#E7FAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4599 39.7544H13.3071C12.7573 38.1317 13.9255 36.3467 15.2656 35.6976C16.6057 35.008 18.1519 35.2108 19.5951 35.3325C21.0383 35.4948 22.5845 35.5759 23.8902 34.7646C26.3986 33.1824 26.7078 29.2474 27.8417 26.1642C29.5254 21.5801 33.7518 18.4969 37.9782 18.6998C42.2046 18.9026 46.1905 22.432 47.5306 27.1784C48.2178 29.6125 48.3896 32.4928 49.9702 34.2372C51.6539 36.1033 54.2997 35.9816 56.4988 35.2514C58.6979 34.5212 60.8626 33.3447 63.1648 33.3853C65.5357 33.507 67.5974 37.0769 67.4599 39.7544Z",
    fill: "#FBEED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.979 10.5045H95.4648C96.5644 7.46196 98.7979 4.78449 101.444 3.72973C104.089 2.6344 107.113 2.95894 109.553 4.54108C111.065 5.51471 112.439 6.97514 114.123 7.25912C116.803 7.74593 119.105 5.2713 121.373 3.48632C125.221 0.484313 130.032 -0.651582 134.568 0.36261C139.069 1.3768 142.299 6.08265 144.979 10.5045Z",
    fill: "#FBEED1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.122 39.3075H164.906C165.078 37.563 166.04 35.4941 167.243 34.4393C168.445 33.3846 170.06 33.0195 171.504 33.3846C172.637 33.6685 173.703 34.3988 174.871 34.5205C176.692 34.7233 178.41 33.4251 179.716 31.9241C181.022 30.3826 182.121 28.5976 183.599 27.34C185.557 25.6767 188.134 25.1088 190.436 25.7984C192.773 26.4881 194.8 28.4353 195.865 30.9911C196.312 32.0864 196.587 33.2629 197.068 34.3582C197.549 35.4535 198.271 36.4677 199.233 36.7923C200.882 37.3602 202.497 35.9809 204.146 35.413C206.724 34.561 209.816 36.5894 211.122 39.3075Z",
    fill: "#FBEED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.299 25.5572H83.4102V26.7337H134.299V25.5572Z",
    fill: "url(#paint0_linear_7261_90361)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.318 27.9104H89.4297V29.0868H140.318V27.9104Z",
    fill: "url(#paint1_linear_7261_90361)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7714 117.565H47.8828V118.741H98.7714V117.565Z",
    fill: "url(#paint2_linear_7261_90361)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.787 119.918H53.8984V121.095H104.787V119.918Z",
    fill: "url(#paint3_linear_7261_90361)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.967 53.6711H90.0781V54.8475H140.967V53.6711Z",
    fill: "url(#paint4_linear_7261_90361)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.75 51.3184H92.8945V52.4949H162.75V51.3184Z",
    fill: "url(#paint5_linear_7261_90361)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.954 48.7212H85.0977V49.8977H154.954V48.7212Z",
    fill: "url(#paint6_linear_7261_90361)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.33 81.5814H54.4414V82.7579H105.33V81.5814Z",
    fill: "url(#paint7_linear_7261_90361)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.118 79.2698H57.2617V80.4463H127.118V79.2698Z",
    fill: "url(#paint8_linear_7261_90361)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.321 76.6726H49.4648V77.8491H119.321V76.6726Z",
    fill: "url(#paint9_linear_7261_90361)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.635 117.078H134.746V118.254H185.635V117.078Z",
    fill: "url(#paint10_linear_7261_90361)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.645 114.725H122.789V115.902H192.645V114.725Z",
    fill: "url(#paint11_linear_7261_90361)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M184.848 112.17H114.992V113.346H184.848V112.17Z",
    fill: "url(#paint12_linear_7261_90361)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3047 87.5489H89.4168C89.2537 85.3698 87.1665 83.2229 85.0141 82.2295C82.8617 81.2361 80.1223 81.3002 78.0677 82.4218C76.0784 83.5113 74.5782 85.498 72.2953 85.8505C70.3712 86.1389 68.5449 85.1776 66.6208 84.8571C63.8814 84.3765 60.0005 85.5301 58.3047 87.5489Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6218 96.073H38.707C40.6638 94.3747 43.4358 93.2211 46.1752 93.0608C48.882 92.9006 52.4042 94.6631 54.6218 96.073Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6564 97.2586H67.8281C68.089 96.3934 69.2631 95.7204 70.2414 95.5923C71.2524 95.4641 72.2634 95.6884 73.2418 95.9127C74.2201 96.137 75.2311 96.3293 76.2421 96.137C77.3509 95.9448 78.3293 95.2718 79.3729 94.8873C82.1123 93.7978 85.7975 95.1116 87.6564 97.2586Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.371 99.3736H136.543C136.804 98.5084 137.978 97.8355 138.956 97.7073C139.967 97.5791 140.978 97.8034 141.957 98.0278C142.935 98.2521 143.946 98.4443 144.957 98.2521C146.066 98.0598 147.044 97.3869 148.088 97.0023C150.827 95.8808 154.512 97.1946 156.371 99.3736Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M148.153 77.3911H126.172C126.955 75.885 129.433 74.8596 131.227 75.2121C132.336 75.4364 133.347 76.0453 134.488 76.0453C135.727 76.0453 136.803 75.3082 137.912 74.8596C141.01 73.5458 146.065 74.9237 148.153 77.3911Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M167.265 90.5934H141.664C141.697 89.6962 142.838 88.863 143.816 88.7669C144.827 88.6707 145.838 88.895 146.849 88.7669C148.219 88.5746 149.328 87.7735 150.502 87.1326C151.676 86.4597 153.078 85.9149 154.383 86.2994C155.916 86.7481 156.731 88.2862 158.231 88.863C159.177 89.2155 160.253 89.1514 161.264 88.9912C162.275 88.831 163.286 88.5746 164.297 88.6707C165.308 88.7669 166.873 89.7282 167.265 90.5934Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.375 80.3711H121.051C120.725 79.2175 119.159 78.4164 117.855 78.5446C116.876 78.6407 115.996 79.2175 115.018 79.1855C113.811 79.1214 112.898 78.1921 111.756 77.7435C110.452 77.1987 108.886 77.391 107.582 77.9357C106.277 78.4484 104.451 79.5059 103.375 80.3711Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 104.886H15.1953V153.113H31.7297V104.886Z",
    fill: "#3851CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 107.161H15.1953V109.596H31.7297V107.161Z",
    fill: "#617AF7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 111.999H15.1953V114.435H31.7297V111.999Z",
    fill: "#617AF7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 116.838H15.1953V119.273H31.7297V116.838Z",
    fill: "#617AF7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 121.677H15.1953V124.112H31.7297V121.677Z",
    fill: "#617AF7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 126.516H15.1953V128.951H31.7297V126.516Z",
    fill: "#617AF7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 131.354H15.1953V133.789H31.7297V131.354Z",
    fill: "#617AF7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 136.193H15.1953V138.628H31.7297V136.193Z",
    fill: "#617AF7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7297 141H15.1953V143.435H31.7297V141Z",
    fill: "#617AF7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 153.125H48.2344L48.2344 104.898H31.7L31.7 153.125Z",
    fill: "#617AF7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 109.608H48.2344V107.172H31.7V109.608Z",
    fill: "#4861DF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 114.438H48.2344V112.002H31.7V114.438Z",
    fill: "#4861DF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 119.268H48.2344V116.832H31.7V119.268Z",
    fill: "#4861DF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 124.098H48.2344V121.662H31.7V124.098Z",
    fill: "#4861DF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 128.928H48.2344V126.492H31.7V128.928Z",
    fill: "#4861DF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 133.758H48.2344V131.322H31.7V133.758Z",
    fill: "#4861DF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 138.588H48.2344V136.152H31.7V138.588Z",
    fill: "#4861DF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 143.45H48.2344V141.014H31.7V143.45Z",
    fill: "#4861DF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6914 91.6501H82.5703V110.14H96.6914V91.6501Z",
    fill: "#3851CC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3432 93.4126H84.4297V96.9375H88.3432V93.4126Z",
    fill: "#4861DF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4081 93.4126H84.4297V96.9375H85.4081V93.4126Z",
    fill: "#617AF7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1517 93.4126H90.2383V96.9375H94.1517V93.4126Z",
    fill: "#4861DF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2166 93.4126H90.2383V96.9375H91.2166V93.4126Z",
    fill: "#617AF7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3432 98.5074H84.4297V102.032H88.3432V98.5074Z",
    fill: "#4861DF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4081 98.5074H84.4297V102.032H85.4081V98.5074Z",
    fill: "#617AF7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1517 98.5072H90.2383V102.032H94.1517V98.5072Z",
    fill: "#4861DF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2166 98.5072H90.2383V102.032H91.2166V98.5072Z",
    fill: "#617AF7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3432 103.602H84.4297V107.127H88.3432V103.602Z",
    fill: "#4861DF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4081 103.602H84.4297V107.127H85.4081V103.602Z",
    fill: "#617AF7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1517 103.602H90.2383V107.127H94.1517V103.602Z",
    fill: "#4861DF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2166 103.602H90.2383V107.127H91.2166V103.602Z",
    fill: "#617AF7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3432 108.698H84.4297V110.108H88.3432V108.698Z",
    fill: "#4861DF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4081 108.698H84.4297V110.108H85.4081V108.698Z",
    fill: "#617AF7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1517 108.698H90.2383V110.108H94.1517V108.698Z",
    fill: "#4861DF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2166 108.698H90.2383V110.108H91.2166V108.698Z",
    fill: "#617AF7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105.695 91.6501H96.7266V110.14H105.695V91.6501Z",
    fill: "#617AF7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 81.2368H112.902V104.886H132.209V81.2368Z",
    fill: "#617AF7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M142.447 81.2368H132.207V104.886H142.447V81.2368Z",
    fill: "#3851CC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M132.208 83.2876H116.652V86.2678H132.208V83.2876Z",
    fill: "#3851CC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M132.208 89.8889H116.652V92.869H132.208V89.8889Z",
    fill: "#3851CC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M132.208 96.4897H116.652V99.4698H132.208V96.4897Z",
    fill: "#3851CC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132.208 103.091H116.652V104.885H132.208V103.091Z",
    fill: "#3851CC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 86.2422H142.449V83.262H132.209V86.2422Z",
    fill: "#4861DF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 92.8516H142.449V89.8714H132.209V92.8516Z",
    fill: "#4861DF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 99.46H142.449V96.4799H132.209V99.46Z",
    fill: "#4861DF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M132.209 104.885H142.449V103.091H132.209V104.885Z",
    fill: "#4861DF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 104.885H113.391V153.112H129.925V104.885Z",
    fill: "#617AF7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 107.16H113.391V109.595H129.925V107.16Z",
    fill: "#4861DF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 111.998H113.391V114.434H129.925V111.998Z",
    fill: "#4861DF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 116.838H113.391V119.273H129.925V116.838Z",
    fill: "#4861DF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 121.676H113.391V124.111H129.925V121.676Z",
    fill: "#4861DF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 126.515H113.391V128.95H129.925V126.515Z",
    fill: "#4861DF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 131.354H113.391V133.789H129.925V131.354Z",
    fill: "#4861DF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 136.192H113.391V138.628H129.925V136.192Z",
    fill: "#4861DF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M129.925 140.999H113.391V143.434H129.925V140.999Z",
    fill: "#4861DF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 153.125H146.449V104.898H129.915V153.125Z",
    fill: "#205A98"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 109.608H146.449V107.172H129.915V109.608Z",
    fill: "#617AF7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 114.438H146.449V112.002H129.915V114.438Z",
    fill: "#617AF7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 119.268H146.449V116.832H129.915V119.268Z",
    fill: "#617AF7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 124.098H146.449V121.662H129.915V124.098Z",
    fill: "#617AF7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 128.928H146.449V126.492H129.915V128.928Z",
    fill: "#617AF7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 133.758H146.449V131.322H129.915V133.758Z",
    fill: "#617AF7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 138.588H146.449V136.152H129.915V138.588Z",
    fill: "#617AF7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M129.915 143.45H146.449V141.014H129.915V143.45Z",
    fill: "#617AF7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M100.083 110.108H62.3828V153.112H100.083V110.108Z",
    fill: "#617AF7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8293 114.274H66.6875V153.112H70.8293V114.274Z",
    fill: "#4861DF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1457 114.274H75.0039V153.112H79.1457V114.274Z",
    fill: "#4861DF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4621 114.274H83.3203V153.112H87.4621V114.274Z",
    fill: "#4861DF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7785 114.274H91.6367V153.112H95.7785V114.274Z",
    fill: "#4861DF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4529 122.35H35.9062V153.112H65.4529V122.35Z",
    fill: "#205A98"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 125.074H38.125V126.548H63.2364V125.074Z",
    fill: "#4861DF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 129.079H38.125V130.553H63.2364V129.079Z",
    fill: "#4861DF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 133.053H38.125V134.527H63.2364V133.053Z",
    fill: "#4861DF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 137.026H38.125V138.5H63.2364V137.026Z",
    fill: "#4861DF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 141.032H38.125V142.506H63.2364V141.032Z",
    fill: "#4861DF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 145.005H38.125V146.479H63.2364V145.005Z",
    fill: "#4861DF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2364 148.979H38.125V150.453H63.2364V148.979Z",
    fill: "#4861DF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M197.138 166.154H14.9336V179.87H197.138V166.154Z",
    fill: "#BCC7FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M197.138 155.836H14.9336V166.155H197.138V155.836Z",
    fill: "#4861DF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M197.138 153.112H14.9336V155.836H197.138V153.112Z",
    fill: "#617AF7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6417 171.955H27.1289C28.5965 170.705 30.7489 170.064 32.7382 170.353C33.9122 170.545 35.0211 170.994 36.1951 171.122C37.6627 171.282 39.1302 170.897 40.5978 170.737C42.0653 170.577 43.6307 170.994 44.6417 171.955Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7726 170.16H53.1836C55.4338 168.75 58.7603 168.142 61.4019 168.814C62.8694 169.167 64.2718 169.872 65.8045 169.776C66.7829 169.712 67.7286 169.359 68.6744 169.199C69.6854 169.071 71.2508 169.423 71.7726 170.16Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2224 175.704H77.5469C82.4713 175.704 87.6241 174.102 92.2224 175.704Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M118.574 176.986H105.855C110.095 176.986 114.726 175.351 118.574 176.986Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M154.837 172.179H134.715C135.563 171.122 137.324 170.801 138.791 170.897C140.226 170.994 141.629 171.41 143.064 171.506C144.955 171.602 146.814 171.122 148.705 170.93C150.564 170.737 153.434 170.994 154.837 172.179Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M184.581 173.301H169.352C173.754 171.025 180.244 170.993 184.581 173.301Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M188.171 183.586H23.8711V187.816H188.171V183.586Z",
    fill: "#99A3B0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M188.171 179.869H23.8711V183.586H188.171V179.869Z",
    fill: "#797C99"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M188.171 187.784H23.8711V201.018H188.171V187.784Z",
    fill: "#797C99"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M169.681 113.216H143.559V153.112H169.681V113.216Z",
    fill: "#4861DF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M150.929 115.651H146.461V153.111H150.929V115.651Z",
    fill: "#617AF7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M158.851 115.651H154.383V153.111H158.851V115.651Z",
    fill: "#617AF7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M166.78 115.651H162.312V153.111H166.78V115.651Z",
    fill: "#617AF7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M185.693 128.246H164.527V153.145H185.693V128.246Z",
    fill: "#205A98"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M194.236 128.246H185.691V153.145H194.236V128.246Z",
    fill: "#4861DF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 130.585H167.297V133.405H185.69V130.585Z",
    fill: "#4861DF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M185.673 133.412H192.75V130.592H185.673V133.412Z",
    fill: "#617AF7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 135.969H167.297V138.789H185.69V135.969Z",
    fill: "#4861DF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M185.673 138.813H192.75V135.993H185.673V138.813Z",
    fill: "#617AF7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 141.385H167.297V144.204H185.69V141.385Z",
    fill: "#4861DF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M185.673 144.182H192.75V141.362H185.673V144.182Z",
    fill: "#617AF7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 146.768H167.297V149.588H185.69V146.768Z",
    fill: "#4861DF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M185.673 149.584H192.75V146.764H185.673V149.584Z",
    fill: "#617AF7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7657 148.658H46.2109V179.869H49.7657V148.658Z",
    fill: "#C7D2D7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7657 148.658H46.2109V151.863H49.7657V148.658Z",
    fill: "#99A3B0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0704 148.658H89.5156V179.869H93.0704V148.658Z",
    fill: "#C7D2D7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0704 148.658H89.5156V151.863H93.0704V148.658Z",
    fill: "#99A3B0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M136.418 148.658H132.863V179.869H136.418V148.658Z",
    fill: "#C7D2D7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M136.418 148.658H132.863V151.863H136.418V148.658Z",
    fill: "#99A3B0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M179.758 148.658H176.203V179.869H179.758V148.658Z",
    fill: "#C7D2D7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M179.758 148.658H176.203V151.863H179.758V148.658Z",
    fill: "#99A3B0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M197.138 144.973H14.9336V148.69H197.138V144.973Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M197.138 147.344H14.9336V148.69H197.138V147.344Z",
    fill: "#C7D2D7"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M171.602 207.914H36.5218C36.2283 207.914 36 207.69 36 207.401C36 207.113 36.2283 206.889 36.5218 206.889H171.602C171.895 206.889 172.123 207.113 172.123 207.401C172.123 207.69 171.895 207.914 171.602 207.914Z",
    fill: "#454F6B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4864 148.244L68.3594 183.07L71.856 183.858L79.983 149.032L76.4864 148.244Z",
    fill: "#FBC623"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5688 150.908C78.8187 151.357 78.2643 152.062 78.0686 152.927L72.7855 176.448C72.4267 178.082 71.0244 179.332 69.3286 179.492H69.2307L68.3828 183.081L71.8723 183.882L79.5688 150.908Z",
    fill: "#D2A417"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8864 132.406L77.4023 147.336L79.6274 147.837L83.1115 132.907L80.8864 132.406Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6463 146.198C78.4616 146.006 79.1138 145.365 79.3095 144.564L80.8096 138.539C81.0705 137.482 81.5597 136.488 82.212 135.623L82.6033 135.11L79.6356 147.832L77.418 147.319L77.6463 146.198Z",
    fill: "#C7D2D7"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8918 146.79L75.5273 148.352L80.8358 149.548L81.2002 147.986L75.8918 146.79Z",
    fill: "#99A3B0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5234 148.344L81.0675 148.568L80.8392 149.562L75.5234 148.344Z",
    fill: "#797C99"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1542 149.273C72.6214 146.164 72.3605 142.511 73.4693 139.243C74.5455 135.974 76.9588 133.154 80.0244 131.52L79.7309 130.943C76.5023 132.642 73.9911 135.59 72.8497 139.018C71.7083 142.447 71.9692 146.293 73.5672 149.529C74.1216 150.619 74.8064 151.644 75.4587 152.669L75.6544 151.804C75.1326 151.003 74.5781 150.17 74.1542 149.273Z",
    fill: "#F0BF6C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6237 157.028C78.5258 156.772 78.428 156.483 78.2976 156.227L78.0367 157.348C79.1455 160.681 78.1997 164.494 75.7864 167.026C75.3951 167.41 75.0037 167.795 74.5471 168.115C73.9927 168.532 73.5036 168.852 73.0144 169.173C72.3947 169.589 71.8403 169.974 71.3185 170.391C70.3728 171.16 69.5901 172.057 68.8726 173.627C67.7312 176.127 67.7312 178.946 68.7748 181.254L69.0357 180.132C68.416 178.177 68.5465 175.934 69.4596 173.915C69.9488 172.858 70.4706 172.121 71.025 171.544C71.6773 170.871 72.4273 170.359 73.3405 169.75C73.7971 169.429 74.3189 169.077 74.9059 168.66C75.1016 168.5 75.2972 168.372 75.4929 168.212C78.6889 165.488 79.9934 160.937 78.6237 157.028Z",
    fill: "#F0BF6C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M130.281 193.11H80.8086V194.264H130.281V193.11Z",
    fill: "#495375"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M130.281 194.232H80.8086V197.853H130.281V194.232Z",
    fill: "#FBC623"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M130.251 199.679H88.7355C87.5289 199.679 86.4527 198.974 85.9961 197.885H130.283V199.679H130.251Z",
    fill: "#422C4F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0497 204.021C77.9723 200.167 77.9723 193.918 74.0497 190.063C70.1271 186.209 63.7673 186.209 59.8447 190.063C55.9221 193.918 55.9221 200.167 59.8447 204.021C63.7673 207.875 70.1271 207.875 74.0497 204.021Z",
    fill: "#422C4F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9473 204.358C71.0539 204.358 74.3829 201.087 74.3829 197.052C74.3829 193.017 71.0539 189.746 66.9473 189.746C62.8408 189.746 59.5117 193.017 59.5117 197.052C59.5117 201.087 62.8408 204.358 66.9473 204.358Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9474 203.717C70.6938 203.717 73.7308 200.733 73.7308 197.052C73.7308 193.371 70.6938 190.387 66.9474 190.387C63.2011 190.387 60.1641 193.371 60.1641 197.052C60.1641 200.733 63.2011 203.717 66.9474 203.717Z",
    fill: "#C7D2D7"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5153 190.579C70.7982 191.476 72.4288 193.655 72.4288 196.219C72.4288 199.584 69.6568 202.307 66.2325 202.307C63.2648 202.307 60.7862 200.256 60.1992 197.533C60.4601 200.961 63.3626 203.685 66.95 203.685C70.6677 203.685 73.7333 200.705 73.7333 197.02C73.7007 193.912 71.4831 191.284 68.5153 190.579Z",
    fill: "#99A3B0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M66.948 199.872C68.533 199.872 69.8179 198.609 69.8179 197.052C69.8179 195.494 68.533 194.232 66.948 194.232C65.363 194.232 64.0781 195.494 64.0781 197.052C64.0781 198.609 65.363 199.872 66.948 199.872Z",
    fill: "#422C4F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0603 184.393L68.8426 183.881L68.0273 187.374C68.7774 187.438 69.5275 187.63 70.245 187.918L71.0603 184.393Z",
    fill: "#797C99"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0283 187.406L65.7454 197.116C65.615 197.724 65.9737 198.333 66.5933 198.461C67.213 198.59 67.8326 198.237 67.963 197.628L70.2459 187.951C69.5284 187.662 68.7783 187.47 68.0283 187.406Z",
    fill: "#99A3B0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8849 197.724C67.119 197.724 67.3088 197.537 67.3088 197.307C67.3088 197.077 67.119 196.891 66.8849 196.891C66.6507 196.891 66.4609 197.077 66.4609 197.307C66.4609 197.537 66.6507 197.724 66.8849 197.724Z",
    fill: "#C7D2D7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2724 201.217H81.6854C80.0222 201.217 78.6851 199.904 78.6851 198.269C78.6851 191.508 73.0758 185.644 66.2272 185.484C65.6728 185.484 65.1184 185.484 64.564 185.548C62.6725 185.74 60.8788 184.714 60.2266 182.952C61.955 182.311 63.7813 181.959 65.6728 181.927C74.8368 181.766 82.305 189.265 82.305 198.269V201.217H82.2724Z",
    fill: "#C7D2D7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0959 183.304C63.9112 183.561 64.8244 183.497 65.7049 183.465C69.4879 183.4 73.2057 184.65 76.3039 186.797C77.7062 187.759 78.9781 188.912 80.1195 190.194C77.2496 185.227 71.836 181.862 65.6723 181.958C64.4004 181.99 63.1285 182.151 61.9219 182.471C62.1828 182.856 62.6067 183.144 63.0959 183.304Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M131.876 197.051H128.289C128.289 189.04 134.909 182.503 143.095 182.503C147.4 182.503 151.509 184.362 154.314 187.566C152.911 188.752 150.857 188.912 149.324 187.887C147.498 186.701 145.345 186.028 143.095 186.028C136.899 186.028 131.876 190.963 131.876 197.051Z",
    fill: "#C7D2D7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M143.099 182.503C138.044 182.503 133.577 185.003 130.902 188.816C131.555 189.104 132.305 188.944 132.761 188.399C135.24 185.515 138.958 183.689 143.099 183.689C147.143 183.689 150.763 185.419 153.242 188.175C153.633 188.015 153.992 187.79 154.318 187.534C151.481 184.362 147.404 182.503 143.099 182.503Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M151.131 202.974C154.467 198.619 153.579 192.431 149.146 189.153C144.714 185.875 138.416 186.748 135.08 191.103C131.744 195.458 132.632 201.646 137.065 204.924C141.497 208.203 147.795 207.329 151.131 202.974Z",
    fill: "#422C4F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M143.096 204.357C147.202 204.357 150.531 201.086 150.531 197.051C150.531 193.016 147.202 189.745 143.096 189.745C138.989 189.745 135.66 193.016 135.66 197.051C135.66 201.086 138.989 204.357 143.096 204.357Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M143.096 203.717C146.842 203.717 149.879 200.733 149.879 197.052C149.879 193.371 146.842 190.386 143.096 190.386C139.35 190.386 136.312 193.371 136.312 197.052C136.312 200.733 139.35 203.717 143.096 203.717Z",
    fill: "#C7D2D7"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M144.66 190.579C146.943 191.476 148.573 193.655 148.573 196.219C148.573 199.584 145.801 202.307 142.377 202.307C139.409 202.307 136.931 200.256 136.344 197.533C136.605 200.961 139.507 203.685 143.094 203.685C146.812 203.685 149.878 200.705 149.878 197.02C149.845 193.912 147.628 191.284 144.66 190.579Z",
    fill: "#99A3B0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M143.096 199.872C144.681 199.872 145.966 198.609 145.966 197.052C145.966 195.494 144.681 194.232 143.096 194.232C141.511 194.232 140.227 195.494 140.227 197.052C140.227 198.609 141.511 199.872 143.096 199.872Z",
    fill: "#422C4F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M84.332 196.058H124.771V196.891H86.7779C85.8974 196.891 85.0169 196.603 84.332 196.058Z",
    fill: "#D2A417"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3868 196.058H94.6367V194.264H95.7129V195.738C95.7455 195.898 95.5825 196.058 95.3868 196.058Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2911 196.058H94.2148V197.853H95.2911V196.058Z",
    fill: "#C7D2D7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M109.637 196.058H108.887V194.264H109.963V195.738C109.963 195.898 109.832 196.058 109.637 196.058Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M109.506 196.058H108.43V197.853H109.506V196.058Z",
    fill: "#C7D2D7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M119.65 198.557H143.392C144.24 198.557 144.924 197.884 144.924 197.051C144.924 196.218 144.24 195.545 143.392 195.545H119.65C118.802 195.545 118.117 196.218 118.117 197.051C118.117 197.884 118.802 198.557 119.65 198.557Z",
    fill: "#E8916A"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M132.009 197.5H138.172C138.433 197.5 138.662 197.276 138.662 197.019C138.662 196.763 138.433 196.539 138.172 196.539H132.009C131.748 196.539 131.52 196.763 131.52 197.019C131.52 197.308 131.748 197.5 132.009 197.5Z",
    fill: "#422C4F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M122.88 197.5H129.044C129.304 197.5 129.533 197.276 129.533 197.019C129.533 196.763 129.304 196.539 129.044 196.539H122.88C122.619 196.539 122.391 196.763 122.391 197.019C122.391 197.308 122.619 197.5 122.88 197.5Z",
    fill: "#422C4F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 197.853C143.551 197.853 143.916 197.494 143.916 197.052C143.916 196.609 143.551 196.25 143.1 196.25C142.65 196.25 142.285 196.609 142.285 197.052C142.285 197.494 142.65 197.853 143.1 197.853Z",
    fill: "#C7D2D7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7461 193.11H100.28L100.084 192.341H87.1048C86.9418 192.565 86.8113 192.822 86.7461 193.11Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M99.138 188.464H92.9743L92.0938 189.457H99.3663L99.138 188.464Z",
    fill: "#422C4F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0977 189.457L91.478 190.13C91.1519 190.515 90.6954 190.771 90.2388 190.899L88.5429 191.348C87.9559 191.508 87.4667 191.86 87.1406 192.341H100.12L99.4028 189.457H92.0977Z",
    fill: "#56438C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6146 134.949L94.0815 162.635L92.2227 188.495H101.419L101.061 183.817C100.93 182.214 100.995 180.644 101.191 179.042L103.604 160.777L99.7561 134.917H98.6146V134.949Z",
    fill: "#454F6B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M100.897 142.287L98.582 141.037L100.213 144.018L100.571 149.914C100.8 153.695 101.843 157.412 103.637 160.777L100.897 142.287Z",
    fill: "#422C4F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7891 134.949L104.061 163.693L107.942 176.671C108.986 180.164 109.508 183.785 109.508 187.438V188.464H118.639L113.617 162.508L114.758 142.64L113.454 134.917H99.7891V134.949Z",
    fill: "#454F6B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M104.059 193.111H117.593L117.397 192.341H104.417C104.287 192.566 104.156 192.822 104.059 193.111Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 188.464H110.287L109.406 189.457H116.679L116.45 188.464Z",
    fill: "#422C4F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M109.41 189.458L108.791 190.131C108.464 190.515 108.008 190.771 107.551 190.9L105.855 191.348C105.268 191.508 104.779 191.861 104.453 192.342H117.433L116.715 189.458H109.41Z",
    fill: "#56438C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M113.456 134.949H98.6172C99.1064 135.782 100.052 136.295 101.031 136.295H103.803L108.27 146.678C108.792 147.895 110.292 148.408 111.466 147.767L114.597 146.101L114.793 142.672L113.456 134.949Z",
    fill: "#422C4F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M112.966 114.857C115.477 117.934 118.575 121.971 120.205 125.56L118.771 126.297C117.173 122.676 115.085 119.279 112.574 116.203L112.966 114.857Z",
    fill: "#8C404C"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M101.68 101.527L102.495 106.013L107.582 103.546L106.441 100.053L101.68 101.527Z",
    fill: "#F0BF9C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 100.245L101.68 101.527L102.006 103.257C102.756 103.129 103.506 102.841 104.126 102.392C104.843 101.847 105.43 101.11 105.789 100.245Z",
    fill: "#422C4F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M102.691 102.104C99.3969 102.104 96.7227 99.4763 96.7227 96.2398V89.6707H108.659V96.2398C108.659 99.4763 105.985 102.104 102.691 102.104Z",
    fill: "#F0BF9C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7223 94.6373L95.5156 98.1943H97.8637L96.7223 94.6373Z",
    fill: "#F0BF9C"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0391 91.7854L101.518 93.9324L102.366 94.317C102.822 94.5092 103.116 94.9578 103.116 95.4385V96.3678C103.116 97.0087 103.409 97.5855 103.931 97.97L104.42 98.3225H107.91L108.431 99.412C109.279 98.643 109.736 97.5855 109.736 96.4639V92.0098L106.279 89.1578L101.289 90.1191L99.0391 91.7854Z",
    fill: "#8C404C"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M106.114 99.3801C107.159 99.3801 108.006 98.548 108.006 97.5215C108.006 96.495 107.159 95.6629 106.114 95.6629C105.07 95.6629 104.223 96.495 104.223 97.5215C104.223 98.548 105.07 99.3801 106.114 99.3801Z",
    fill: "#F0BF9C"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 98.6108C106.725 98.6108 107.222 98.123 107.222 97.5213C107.222 96.9196 106.725 96.4318 106.113 96.4318C105.5 96.4318 105.004 96.9196 105.004 97.5213C105.004 98.123 105.5 98.6108 106.113 98.6108Z",
    fill: "#EBA588"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7227 92.9066V94.637L96.9183 94.8934C97.6032 95.7586 98.8098 96.0149 99.7882 95.4702L101.68 94.4127L96.7227 92.9066Z",
    fill: "#EBA588"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M100.897 102.201L99.8203 101.816L104.19 92.8117L105.201 93.3564L100.897 102.201Z",
    fill: "#454F6B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 88.71C106.28 88.5498 107.715 88.646 109.052 88.3576C110.324 88.0692 111.53 87.4283 112.476 86.531C112.411 86.1465 112.248 85.794 111.954 85.5056C111.857 85.4095 111.759 85.3454 111.661 85.2813C111.302 85.9542 110.683 86.4669 109.965 86.7874C108.987 87.236 107.878 87.3001 106.802 87.268C105.726 87.236 104.649 87.0758 103.573 87.1078C101.649 87.1399 99.7575 87.7487 98.1595 88.8382C96.8224 89.7355 95.7462 90.9532 94.9961 92.3631C94.9961 92.3631 94.9961 92.3631 95.0287 92.3631L97.0507 92.972C98.9748 90.6327 101.845 89.0625 104.91 88.71Z",
    fill: "#E8916A"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1903 88.8384C99.7556 87.7489 101.68 87.1401 103.604 87.108C104.68 87.076 105.756 87.2362 106.832 87.2682C107.909 87.3003 109.018 87.2362 109.996 86.7876C110.713 86.4671 111.333 85.9224 111.692 85.2815C111.105 84.8969 110.355 84.8649 109.735 85.2174L108.463 85.9544C108.104 86.1787 107.648 86.2108 107.224 86.1146L105.952 85.7301C101.484 84.4163 96.6575 86.371 94.4725 90.4406L94.342 90.665C93.9833 91.3058 94.3094 92.107 95.0269 92.3633C95.7769 90.9854 96.8858 89.7357 98.1903 88.8384Z",
    fill: "#CC6164"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M112.475 86.5309C111.529 87.4282 110.323 88.0691 109.051 88.3575C107.681 88.6459 106.279 88.5497 104.909 88.71C101.876 89.0304 98.9735 90.6326 97.082 93.0039L101.419 94.3178C101.876 94.4459 102.398 94.3819 102.789 94.1255L111.692 88.2613C112.279 87.8768 112.573 87.1718 112.475 86.5309ZM101.876 92.8117L100.245 92.299C101.68 90.921 103.702 90.184 105.724 90.2802L101.876 92.8117Z",
    fill: "#CC6164"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M110.094 89.3183L103.637 93.5802L105.3 94.2532L110.648 91.0807L110.094 89.3183Z",
    fill: "#422C4F"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M110.649 91.0807L105.301 94.2531L106.899 94.894L111.138 92.6509L110.649 91.0807Z",
    fill: "#454F6B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M111.135 92.6509L106.863 94.894L109.244 95.8554C109.701 96.0476 110.19 95.9195 110.516 95.567L110.972 95.0863C111.396 94.6377 111.527 93.9968 111.364 93.42L111.135 92.6509Z",
    fill: "#4F5D7A"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M114.854 110.115C114.201 109.571 113.875 108.738 113.451 108C112.44 106.206 110.777 104.828 108.82 104.091L112.766 109.603L113.68 110.949C114.136 111.622 114.984 111.878 115.734 111.622C116.158 111.461 116.484 111.173 116.68 110.788C116.028 110.788 115.343 110.532 114.854 110.115Z",
    fill: "#CCA11F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M116.811 109.474L115.866 106.43C115.703 105.885 115.703 105.276 115.931 104.731C116.159 104.155 116.159 103.514 115.963 102.937L115.148 100.566L108.234 103.257L108.821 104.091C110.746 104.828 112.441 106.238 113.452 108C113.876 108.737 114.202 109.57 114.855 110.115C115.344 110.564 116.029 110.788 116.714 110.756C116.909 110.371 116.974 109.923 116.811 109.474Z",
    fill: "#FBC623"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M102.301 106.109L108.237 103.225L110.617 105.981C112.835 108.544 113.846 111.909 113.389 115.242L112.965 118.414C112.607 120.914 112.802 123.445 113.455 125.88L114.563 130.014C114.889 131.168 114.726 132.385 114.205 133.443L113.422 134.917H98.5834L97.8007 133.827C97.1158 132.898 96.9528 131.713 97.3767 130.655L97.9963 129.021C98.192 128.54 98.2572 128.027 98.192 127.483L97.018 115.434C96.8223 113.575 97.2136 111.717 98.1268 110.05C99.0725 108.352 100.507 106.974 102.301 106.109Z",
    fill: "#FBC623"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M123.235 139.627L110.875 145.972C110.093 146.388 109.082 146.068 108.69 145.299L103.277 135.141C102.853 134.371 103.179 133.378 103.962 132.994L116.322 126.649C117.104 126.232 118.115 126.553 118.507 127.322L123.92 137.48C124.344 138.249 124.018 139.21 123.235 139.627Z",
    fill: "#8C404C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M126.693 137.833L114.332 144.177C113.55 144.594 112.539 144.273 112.147 143.504L106.734 133.346C106.31 132.577 106.636 131.584 107.419 131.199L119.779 124.855C120.561 124.438 121.572 124.758 121.964 125.527L127.377 135.686C127.801 136.487 127.508 137.448 126.693 137.833Z",
    fill: "#A64F5A"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M125.907 132.93L114.428 138.826C112.341 139.884 109.797 139.115 108.721 137.064L106.992 133.827L122.255 126.008L125.907 132.93Z",
    fill: "#422C4F"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M106.733 133.346L107.124 134.115C107.907 135.621 109.244 136.775 110.875 137.352C111.56 137.608 112.31 137.544 112.962 137.224L125.42 130.815C126.137 130.43 126.072 129.373 125.289 129.116C124.213 128.764 123.3 127.995 122.778 127.001L121.995 125.527C121.572 124.758 120.593 124.438 119.81 124.855L107.45 131.199C106.635 131.616 106.309 132.577 106.733 133.346Z",
    fill: "#BD6C67"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M109.963 110.178L104.093 110.082L99.8203 116.01C100.57 119.695 101.777 123.509 102.918 126.809C104.582 126.296 105.951 125.111 106.669 123.477L110.485 114.632C111.072 113.158 110.876 111.46 109.963 110.178Z",
    fill: "#CCA11F"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M97.375 119.311L98.1903 127.482L101.419 127.066C100.18 123.317 99.3643 119.952 98.8752 117.26L97.375 119.311Z",
    fill: "#CCA11F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9405 108.8C98.9405 108.8 98.0273 109.345 98.0273 110.21C98.0273 110.21 98.0926 112.902 98.8753 117.26L99.7884 115.978C99.2666 113.479 98.9405 111.011 98.9405 108.8Z",
    fill: "#BD6C67"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M101.422 127.066C102.4 129.95 103.607 133.058 105.205 136.295L106.575 135.718C106.085 134.789 104.52 131.264 102.922 126.777C102.596 126.874 102.27 126.938 101.944 127.002L101.422 127.066Z",
    fill: "#BD6C67"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M98.875 117.26C99.3642 119.984 100.179 123.316 101.419 127.066L101.941 127.001C102.267 126.969 102.593 126.873 102.919 126.777C101.745 123.477 100.571 119.663 99.8208 115.978L98.875 117.26Z",
    fill: "#8C404C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6998 120.753L104.059 110.051C105.038 108.416 107.19 107.904 108.821 108.961C110.321 109.922 110.777 111.845 109.929 113.351L104.451 122.9C103.635 124.31 102.429 125.432 100.961 126.169L89.4489 131.745C88.7641 132.065 87.9488 131.745 87.6552 131.072L86.2203 127.387C85.9594 126.746 86.2529 126.041 86.8725 125.752L97.6998 120.753Z",
    fill: "#FBC623"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1881 127.387L83.7422 128.188L85.4054 132.322L87.6557 131.072L86.1881 127.387Z",
    fill: "#FBC623"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9394 128.701L79.6999 128.22C79.2107 128.156 78.7215 128.508 78.6237 128.989L77.9714 132.354C77.9062 132.674 78.0693 132.994 78.3302 133.155L80.2543 134.244C80.7761 134.565 81.4935 134.276 81.624 133.667C82.9611 133.603 84.1677 132.962 84.9504 131.905L85.1461 131.649L83.9394 128.701Z",
    fill: "#F0BF9C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9399 128.701C83.8095 129.822 84.2661 130.944 85.1466 131.649L83.9399 128.701Z",
    fill: "#EBA588"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9798 134.405C82.9524 134.405 83.7409 133.63 83.7409 132.674C83.7409 131.719 82.9524 130.944 81.9798 130.944C81.0072 130.944 80.2188 131.719 80.2188 132.674C80.2188 133.63 81.0072 134.405 81.9798 134.405Z",
    fill: "#99A3B0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9809 133.603C82.5032 133.603 82.9267 133.187 82.9267 132.674C82.9267 132.161 82.5032 131.745 81.9809 131.745C81.4586 131.745 81.0352 132.161 81.0352 132.674C81.0352 133.187 81.4586 133.603 81.9809 133.603Z",
    fill: "#797C99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7261_90361",
    x1: 83.4105,
    y1: 26.1582,
    x2: 134.302,
    y2: 26.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7261_90361",
    x1: 89.4301,
    y1: 28.5154,
    x2: 140.322,
    y2: 28.5154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7261_90361",
    x1: 47.8815,
    y1: 118.155,
    x2: 98.7731,
    y2: 118.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7261_90361",
    x1: 53.8973,
    y1: 120.513,
    x2: 104.789,
    y2: 120.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7261_90361",
    x1: 90.089,
    y1: 54.248,
    x2: 140.981,
    y2: 54.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7261_90361",
    x1: 92.9084,
    y1: 51.9098,
    x2: 162.748,
    y2: 51.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7261_90361",
    x1: 85.1127,
    y1: 49.325,
    x2: 154.952,
    y2: 49.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7261_90361",
    x1: 54.4323,
    y1: 82.1893,
    x2: 105.324,
    y2: 82.1893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7261_90361",
    x1: 57.2557,
    y1: 79.8517,
    x2: 127.095,
    y2: 79.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7261_90361",
    x1: 49.46,
    y1: 77.2669,
    x2: 119.299,
    y2: 77.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7261_90361",
    x1: 134.748,
    y1: 117.669,
    x2: 185.639,
    y2: 117.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7261_90361",
    x1: 122.777,
    y1: 115.331,
    x2: 192.616,
    y2: 115.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#617AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7261_90361",
    x1: 114.981,
    y1: 112.748,
    x2: 184.82,
    y2: 112.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FCBD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#7FCBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9884,
    stopColor: "#7FCBD0",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction2);
export default __webpack_public_path__ + "static/media/auction2.6c247e5ee69f82b317a1ac7db9e1a68e.svg";
export { ForwardRef as ReactComponent };